<template>
    <div class="HomePage">
        <div class="home-top">
            <img src="@/assets/img/home/home1.png" alt="">
            <div class="banner">
               <a :href="imgLink"><img :src='thumb' alt=""></a> 
            </div>
        </div>
        <div class="home-notice">
            <div class="notice-left">
                <img src="@/assets/img/home/notice.png" alt="">
            </div>
            <div class="notice-right">{{noticeText}}</div>
        </div>
        <div class="input-lists">
            <div class="input-item">
                <img src="@/assets/img/home/cardNum.png" alt="">
                <input type="text" :placeholder="placeholder1" @focus="onInputFocus1" @blur="inputBurl" v-model.trim="cardNum"/>
            </div>
            <div class="input-item">
                <img src="@/assets/img/home/password.png" alt="">
                <input type="text" :placeholder="placeholder2" @focus="onInputFocus2"   @blur="inputBurl" v-model.trim="password"/>
            </div>
            <div class="input-item">
                <img src="@/assets/img/home/code.png" alt="">
                <input type="text"  class="input-code" @focus="onInputFocus3" @blur="inputBurl" :placeholder="placeholder3" v-model.trim="codeNum"/>
                <img class="code-img" @click="apiVerify_code" :src="verify_code.code_img" alt="" />
            </div>
        </div>
        <div class="buttons">
            <button @click="exchange">兑换</button>
        </div>
        <div class="reminder" v-if="bottomNotice">
            <div>温馨提示：</div>
            <div v-html="bottomNotice">{{bottomNotice}}</div>
        </div>
        <!-- isMaskPop && popContent -->
        <maskPop :show = "isMaskPop && popContent">
            <div class="maskContent">
                <!-- <div class="mask-text" v-html="popContent">
                    这里是用户谐音
                </div> -->
                <div class="maskText">
                    <div v-html="popContent"></div>
                    <div class="button">
                        <van-button type="default" @click="closeMask">确定</van-button>
                    </div>
                </div>
               
            </div>
        </maskPop>
        <maskPop :show ="true" v-if='isMaskPop1==1'>
            <div class="maskContent">
                <div class="maskText" v-html="isMaskPopText">

                </div>
            </div>
        </maskPop>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import {wechatHome,apiCheck,apiVerify_code,apiOpenid} from '@api';
import maskPop from '@components/maskPop'



export default {
    
    data(){
        return{
            InnerHeight:window.innerHeight,
            cardNum:'',
            password:'',
            codeNum:'',
            thumb:"",
            verify_code:{},
            placeholder1:"请输入卡券号码",
            placeholder2:"请输入卡券密码",
            placeholder3:"请输入右侧4位数字验证码",
            noticeText:"因疫情影响，部分礼品可能存在缺货，请谅解。",//上面提示
            bottomNotice:"兑换码仅可使用一次，多次输错，将被系统禁用。",//下边提示
            imgLink:"",//接口返回的图片链接
            isMaskPop:true,
            popContent:"",
            isMaskPop1:0,
            isMaskPopText:"",

        }
    },
    components:{
        maskPop
    },
    created(){
        this.wechatHome()
    },
    watch:{
        windowInnerHeight:function(){
            if(this.windowInnerHeight!=this.InnerHeight){
                this.$store.commit('changeHasBar',{
                    hasBar:false
                })
            }else{
                this.$store.commit('changeHasBar',{
                    hasBar:true
                })
            }
            
        }
  },
  
    methods:{
         /**
         * 首页接口调取
         */
        async wechatHome(){
            const[err,data] = await wechatHome();
            if(err) return console.warn(err);
            this.thumb = data.banner[0].thumb
            this.verify_code = data.verify_code
            this.imgLink = data.banner[0].link
            this.bottomNotice = data.notice.static;
            this.popContent = data.notice.pop;
            this.noticeText = data.notice.top;
            this.isMaskPopText = data.shutdown.reason;
            this.isMaskPop1 = data.shutdown.status;
               
            
        },
        /**
         * 关闭弹出框
         */
        closeMask(){
            this.isMaskPop = false;
        },
        /**
         * 请求微信接口
         */
        async getOpenid(){
            const [err,data] = await apiOpenid({
                code:this.$store.state.code,
            })
            if(err) return console.warn(err)
            this.$store.commit("storeOpenid",{
                openid:data.openid
            })
            this.wechatHome({
                openid:data.openid
            })
        },
        onInput(){
            let  pattern3 = /^[0-9]+$/;
            if(!pattern3.test(this.cardNum)){
                this.$toast("输入卡号有误")
                this.cardNum=""
                return 
            }
        },
        onInput1(){
            let pattern = /^[0-9a-zA-Z]*$/
            if(!pattern.test(this.password)){
                this.$toast("输入密码有误")
                this.password=""
                return 
            }
        },
        onInputFocus1(){
            // this.placeholde1 =""
        },
         onInputFocus2(){
            // this.placeholder2 =""
        },
         onInputFocus3(){
            // this.placeholder3 =""
        },
        //清除空格
        removeAllSpace(str) {
            // return str
            return str.replace(/\s+/g, "");
        },
       
        async apiCheck(){
            let param ={
                card_code:this.removeAllSpace(this.cardNum),
                card_password:this.removeAllSpace(this.password),
                verify_code:this.removeAllSpace(this.codeNum),
                key:this.removeAllSpace(this.verify_code.key)
            }
            const [err,data] = await apiCheck(param);
            if(err) return this.apiVerify_code();
            this.$store.commit("storeChooseGifts",{
                chooseGifts:data
            })
         
            window.sessionStorage.setItem("storeChooseGifts",JSON.stringify(data));
            this.$router.push({
                    name:'ExchangeIndex',
            })
            
        },
        async apiVerify_code(){
            const [err,data] = await apiVerify_code()
            if(err) return console.warn(err)
            this.verify_code = data
            console.log(data)
        },
        exchange(){
            
            let {cardNum,password,codeNum} = this
            if(!this.removeAllSpace(cardNum)) return this.$toast('请输入卡号');
            if(!this.removeAllSpace(password)) return this.$toast('请输入密码');
            if(!this.removeAllSpace(codeNum)) return this.$toast('请输入验证码');
            if(this.removeAllSpace(cardNum).length<6) return this.$toast('卡号输入错误');
           
            if(this.removeAllSpace(password).length<6) return this.$toast('输入密码错误');
            if(this.removeAllSpace(codeNum).length!==4) return this.$toast("验证码错误")
            this.apiCheck()
           
        }
    },
    computed:mapState(['windowInnerHeight'])

}
</script>
<style lang='scss' scoped>
.HomePage{
    width: 100%;
    height:calc(100% - 1.33333rem);
    .home-top{
        width:100%;
        position: relative;
        height:268px;
        img{
            width: 100%;
            height:100%;
        }
        .banner{
            width: 100%;
            height: 240px;
            position: absolute;
            bottom: -28px;
            text-align: center;
            img{
                width: 702px;
                height: 240px;
                box-shadow:0px 4px 32px 0px rgba(4,0,0,0.14);
            }
        }
    }
    .home-notice{
        width:702px;
        height:60px;
        background:rgba(251,251,251,1);
        box-shadow:0px 4px 32px 0px rgba(4,0,0,0.14);
        border-radius:10px;
        margin: 0 auto;
        display: flex;
        margin-top: 58px;
        align-items: center;
        padding-left: 8px;
        padding-right: 8px;
        box-sizing: border-box;
        // justify-content: space-between;
        .notice-left{
            width: 79px;
            height: 30px;
            margin-right: 6px;
            img{
                width: 79px;
                height: 30px;
            }
        }
        .notice-right{
            font-size:28px;
            font-family:PingFang SC;
            font-weight:500;
            color:rgba(136,136,136,1);
        }
    }
    .input-lists{
        padding: 0 62px;
        padding-top:60px ;
        .input-item{
            display: flex;
            align-items: center;
            padding-top:40px;
            padding-bottom: 12px;
            border-bottom:1px solid #BFBFBF;
            position: relative;
            img{
                width: 40px;
                height: 40px;
                margin-right: 26px;
            }
            .code-img{
                width: 200px;
                position: absolute;
                right: 0;
                margin-right: 0;
            }
            input{
                border: none;
                font-size:28px;
                font-family:PingFang SC;
                font-weight:500;
                width: 80%;
                &::placeholder{
                color:#888888;
                }
            }
            .input-code{
                width: 60%;
            }
            
        }
    }
   
    .buttons{
        display: block;
        width: 100%;
        text-align: center;
        padding-top: 56px;
         button{
            width:619px;
            height:80px;
            background:linear-gradient(0deg,rgba(255,74,74,1),rgba(255,70,70,1));
            border-radius:40px;
            font-size:38px;
            font-family:PingFang SC;
            font-weight:500;
            color:rgba(255,255,255,1);
            border: none;
            margin: 0 auto;
        }
    }
    .reminder{
        padding: 0 30px;
        padding-top:52px;
        font-size:30px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(136,136,136,1);
        text-align: center ;
        line-height: 50px;
        
    }
    .maskContent{
        width: 90%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border-radius: 10px;
        display: flex;
        align-items: center;
       
       .maskText{
           background: #fff;
           padding: 40px;
           border-radius: 10px;
           font-size: 28px;
           line-height: 40px;
           width: 100%;
           box-sizing: border-box;
           max-height: 80%;
           overflow: auto;

       }
       .button {
           text-align: center;
           margin-top: 50px;
       }
        .van-button {
        width: 350px;
        border-radius: 40px;
        background: #FF4848;
        color: #fff;
        font-size: 38px;
    }
       
       
        
    }
   
}
</style>